import React from 'react';
import { Lock, Shield, CreditCard } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0a0a0a] py-12 sm:py-20 px-6 border-t border-gray-900/60" data-id="element-79">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center gap-12" data-id="element-80">
        {/* Main quote */}
        <p className="font-serif italic text-[#d4a85a] text-2xl sm:text-3xl lg:text-[34px] leading-[1.4] font-normal max-w-2xl" data-id="element-81">
          "The truth does not need permission to exist."
        </p>

        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4 text-xs text-gray-400 uppercase tracking-[0.2em] font-semibold" data-id="element-82">
          <div className="flex items-center gap-2" data-id="element-83">
            <Lock className="w-4 h-4" strokeWidth={1.5} data-id="element-84" />
            <span data-id="element-85">SSL 256-Bit</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-86">
            <Shield className="w-4 h-4" strokeWidth={1.5} data-id="element-87" />
            <span data-id="element-88">Secure Checkout</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-89">
            <CreditCard className="w-4 h-4" strokeWidth={1.5} data-id="element-90" />
            <span data-id="element-91">Protected Payment</span>
          </div>
        </div>

        {/* Copyright */}
        <div className="flex flex-col items-center gap-2 pt-6 border-t border-gray-900 w-full max-w-md" data-id="element-92">
          <p className="text-xs text-gray-500" data-id="element-93">
            © 2026 Nicolás Pereira — All rights reserved.
          </p>
          <p className="text-[11px] text-gray-600 italic" data-id="element-94">
            Venezuela — The truth the world refused to see
          </p>
        </div>
      </div>
    </footer>;
}